/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_3_ClientInputs */

const et_portfolio_project_3_client = /** @type {(inputs: Portfolio_Project_3_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serena Käsitöö kommid (Käsitöökommipood)`)
};

const en_portfolio_project_3_client = /** @type {(inputs: Portfolio_Project_3_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serena Käsitöö kommid (Handmade candy store)`)
};

/**
* | output |
* | --- |
* | "Serena Käsitöö kommid (Handmade candy store)" |
*
* @param {Portfolio_Project_3_ClientInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_3_client = /** @type {((inputs?: Portfolio_Project_3_ClientInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_3_ClientInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_3_client(inputs)
	return en_portfolio_project_3_client(inputs)
});